export * from "./skyscraper1";
export * from "./skyscraper2";
export * from "./skyscraper3";
export * from "./skyscraper4";
export * from "./skyscraper5";
export * from "./skyscraper6";
export * from "./skyscraper7";
export * from "./skyscraper8";
export * from "./skyscraper9";



import { Skyscraper1Component } from "./skyscraper1";
import { Skyscraper2Component } from './skyscraper2';
import { Skyscraper3Component } from "./skyscraper3";
import { Skyscraper4Component } from "./skyscraper4";
import { Skyscraper5Component } from "./skyscraper5";
import { Skyscraper6Component } from "./skyscraper6";
import { Skyscraper7Component } from "./skyscraper7";
import { Skyscraper8Component } from "./skyscraper8";
import { Skyscraper9Component } from "./skyscraper9";

export const BuildingOrganisms = [
    Skyscraper1Component,
    Skyscraper2Component,
    Skyscraper3Component,
    Skyscraper4Component,
    Skyscraper5Component,
    Skyscraper6Component,
    Skyscraper7Component,
    Skyscraper8Component,
    Skyscraper9Component
];
